import { cn as b } from "../../../lib/utils.es.js";
import { jsx as r } from "react/jsx-runtime";
var d = ({ className: i, type: l, ...e }) => /* @__PURE__ */ r("input", {
  className: b("lib:flex lib:h-9 lib:w-full lib:rounded-md lib:border lib:border-input lib:bg-white lib:px-3 lib:py-1 lib:text-base lib:shadow-sm lib:transition-colors lib:file:border-0 lib:file:bg-transparent lib:file:font-medium lib:file:text-foreground lib:file:text-sm lib:placeholder:text-muted-foreground lib:focus-visible:outline-none lib:focus-visible:ring-2 lib:focus-visible:ring-blue-400 lib:disabled:cursor-not-allowed lib:disabled:opacity-50 lib:aria-invalid:border-destructive lib:aria-invalid:focus-visible:ring-red-400 lib:md:text-sm", i),
  "data-slot": "input",
  type: l,
  ...e
});
export {
  d as Input
};
